/**
 * Redirect to login after session expiry.
 * In Electron (file://) assign("/") navigates to file:/// and crashes the app.
 */
export const redirectToLogin = () => {
  localStorage.removeItem("authData");

  if (window.location.protocol === "file:") {
    window.location.hash = "#/login";
    return;
  }

  window.location.assign("/");
};
